<div class="action-container">
  <span *ngIf="componentId">
    <app-filteroption [componentId]="componentId" (refreshSummary)="refreshSummary($event)" [isCustomFilter]="true"></app-filteroption>
  </span>
  <button *ngIf="columns.length > 0" class="btn btn-contextMenu" (click)="onContextMenu($event)">Columns</button>
  <button class="btn btn-contextMenu" (click)="export()">Export source view</button>
  <button *ngIf="showReportExportCurrentView" class="btn btn-contextMenu" (click)="exportCurrent()">Export current view</button>
  <button class="btn btn-contextMenu" (click)="onSave()">Save</button>
  <!-- <button class="btn btn-contextMenu" (click)="getState()">Get state</button> -->
  <span *ngIf="isSaving" style="position: absolute;right: 2px;font-size: 13px;top: 10px;color: var(--primary);display: inline-flex;">
    <mat-spinner diameter="16" style="margin-right: 5px;"></mat-spinner>
    Saving...
  </span>
</div>

<div class="clearfix"></div>
<ag-grid-angular #agGrid
  [ngStyle]="{'width': '100%', 'height': isPopup ? '65vh' : '415px'}" 
  class="ag-theme-balham ag-main-container"
  [rowData]="rowData" 
  [columnDefs]="columnDefs"
  [modules]="modules"
  (gridReady)="onGridReady($event)"
  (firstDataRendered)="firstDataRendered($event)"
  [overlayNoRowsTemplate]="noRowsTemplate"
  [gridOptions]="gridOptions"
  >
</ag-grid-angular>

<!-- <p (click)="resizeColumn()">resize</p> -->

<!-- <p>Select which columns to display:</p>
<ng-container *ngIf="columns.length > 0">
  <div *ngFor="let column of columns; let i=index" class="mat-checkbox-container">
    <mat-checkbox matCheckbox #matCheckbox="matCheckbox"
    class="form-checkbox"
    (change)="onChange(column, $event)"
    [value]="column.field"
    [(ngModel)]="column.isChecked">{{column.headerName}}</mat-checkbox>
  </div>
</ng-container> -->
<p *ngIf="agGrid.api" class="table-footer"><span>Rows displayed :</span> {{rowCount == 0 ? '0' : rowCount}} / {{totalRowsCount}}</p>
<context-menu [useBootstrap4]="true">
  <ng-template contextMenuItem passive="true">
    <div class="columns-display">
      <div *ngFor="let column of columns; let i=index" class="mat-checkbox-container">
        <mat-checkbox matCheckbox #matCheckbox="matCheckbox"
        class="form-checkbox"
        (change)="onChange(column, $event)"
        [value]="column.field"
        [(ngModel)]="column.isChecked">{{column.headerName}}</mat-checkbox>
      </div>
    </div>
  </ng-template>
</context-menu>